module.exports = __webpack_public_path__ + "6cd517195b5cde7ee61349651c82b562.json";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader!./src/assets/AllSets.json
// module id = 48
// module chunks = 0